import React from 'react';
import { Handle, Position } from 'reactflow';
import JustificationContainer from '~/components/atom/JustificationContainer';
import { FlowAction } from '~/graphql/types';
import { ClientFlowActionStopFlows } from '~/graphql/types.client';
import getCardHeading from '../../../../utils/getCardHeading';
import CardTemplate, { handleStyle, Props as CardProps } from '../CardTemplate';
import { Body } from '~/components/atom/Typography';
import IssuesForAction from '../IssuesForAction';
import Icon from '~/components/atom/Icon';
import Spinner from '~/components/atom/Icon/components/Spinner';
import useFlows from '~/hooks/useFlows';

export type Props = Omit<
  CardProps<ClientFlowActionStopFlows>,
  'heading' | 'actionType'
> & {
  dataTestId?: string;
};

const text = {
  empty: '-',
};

const StopFlowsCard: React.FCC<Props> = React.memo(
  ({ selected, disabled, data, ...props }) => {
    const action = data.action;
    const { flows, loading } = useFlows();
    const selectedFlows = flows?.filter(flow =>
      action.toStopFlowBlueprintIds.includes(flow.id),
    );

    return (
      <>
        <Handle
          type="target"
          position={Position.Top}
          style={handleStyle}
          isConnectable={false}
        />
        <CardTemplate
          {...props}
          actionType={FlowAction.StopFlows}
          heading={getCardHeading(FlowAction.StopFlows)}
          selected={selected}
          disabled={disabled}
          data={data}
          dataTestId="StopFlowsCard"
        >
          {loading ? (
            <Spinner />
          ) : (
            <JustificationContainer direction="column" width="100%" gap="xxs">
              {selectedFlows.length > 0 &&
                selectedFlows.map(flow => (
                  <JustificationContainer
                    align="center"
                    gap="xxs"
                    key={flow.id}
                  >
                    <Icon name="flow" />
                    <Body margin={[null]}>{flow.name || text.empty}</Body>
                  </JustificationContainer>
                ))}

              <IssuesForAction
                margin={['base', null, null]}
                actionId={action.id}
              />
            </JustificationContainer>
          )}
        </CardTemplate>
        <Handle
          type="source"
          position={Position.Bottom}
          style={handleStyle}
          isConnectable={false}
        />
      </>
    );
  },
);

export default StopFlowsCard;
